import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class ThemeToggle extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    // Компонент хранит только представление текущего состояния. Чтение DOM и localStorage
    // остаётся ответственностью переданного сервиса, чтобы UI не дублировал доменную логику.
    this.preference = vnode.attrs.preference;
    this.theme = this.preference.current();
    this.saving = false;
  }
  view() {
    // Перед каждой отрисовкой состояние сверяется с реальным data-theme. Это учитывает позднюю
    // инициализацию auto-схемы ядром Flarum и изменение темы на странице настроек профиля.
    this.theme = this.preference.current();
    const dark = this.theme === 'dark';
    const label = dark ? 'Включить светлую тему' : 'Включить тёмную тему';
    return m('button', {
      type: 'button',
      className: `dc-theme-toggle${dark ? ' is-dark' : ''}`,
      role: 'switch',
      'aria-checked': dark ? 'true' : 'false',
      'aria-label': label,
      title: label,
      disabled: this.saving,
      onclick: () => this.switchTheme()
    }, [
    // Обе пиктограммы остаются декоративными: смысл и текущее действие уже полностью
    // описаны через aria-label и роль switch для клавиатуры и экранных дикторов.
    m('span', {
      className: 'dc-theme-toggle__icon dc-theme-toggle__icon--sun',
      'aria-hidden': 'true'
    }, m('i', {
      className: 'fas fa-sun'
    })), m('span', {
      className: 'dc-theme-toggle__thumb',
      'aria-hidden': 'true'
    }), m('span', {
      className: 'dc-theme-toggle__icon dc-theme-toggle__icon--moon',
      'aria-hidden': 'true'
    }, m('i', {
      className: 'fas fa-moon'
    }))]);
  }
  switchTheme() {
    // Повторное нажатие блокируется на время серверного сохранения, чтобы быстрые клики
    // не отправили взаимоисключающие значения preference в неправильном порядке.
    if (this.saving) {
      return;
    }
    const previousTheme = this.theme;
    const nextTheme = this.preference.toggle();

    // Flarum уведомляется через публичный метод приложения: так его собственные компоненты
    // и базовые CSS-переменные переключаются вместе с фирменными токенами DevConnect.
    app.setColorScheme(nextTheme);
    this.theme = nextTheme;

    // Гость сохраняет выбор только локально. Для авторизованного пользователя preference
    // дополнительно синхронизируется с профилем и будет работать на другом устройстве.
    if (!app.session.user) {
      m.redraw();
      return;
    }
    this.saving = true;
    app.session.user.savePreferences({
      colorScheme: nextTheme
    }).catch(() => {
      // Если API не сохранил настройку, интерфейс возвращается в подтверждённое состояние,
      // а пользователь получает понятное сообщение вместо незаметной рассинхронизации.
      this.preference.apply(previousTheme);
      this.preference.remember(previousTheme);
      app.setColorScheme(previousTheme);
      this.theme = previousTheme;
      app.alerts.show({
        type: 'error'
      }, 'Не удалось сохранить тему профиля. Попробуйте ещё раз.');
    }).finally(() => {
      // Флаг снимается в единой точке для успешного и ошибочного ответа, после чего Mithril
      // обновляет положение бегунка и доступность кнопки.
      this.saving = false;
      m.redraw();
    });
  }
}
flarum.reg.add('devconnect-theme', 'forum/components/ThemeToggle', ThemeToggle);